type InputProps = {
    value: string;
    onChange: (value: string) => void;
    label?: string;
    placeholder?: string;
    type?: 'text' | 'email' | 'number';
    hint?: string;
    disabled?: boolean;
    autoFocus?: boolean;
    /** Marks the field red and wires it to the message the form is showing. */
    invalid?: boolean;
    /** Hides the label visually but keeps it for screen readers. */
    hideLabel?: boolean;
    name?: string;
    autoComplete?: string;
    describedBy?: string;
    min?: number | string;
    max?: number | string;
    step?: number | string;
    onBlur?: () => void;
};

export function Input({
    value,
    onChange,
    label,
    placeholder,
    type = 'text',
    hint,
    disabled = false,
    autoFocus = false,
    invalid = false,
    hideLabel = false,
    name,
    autoComplete,
    describedBy,
    min,
    max,
    step,
    onBlur,
}: InputProps) {
    return (
        <label className="block">
            {label ? <span className={hideLabel ? 'sr-only' : 'eyebrow mb-2 block text-text-muted'}>{label}</span> : null}

            <input
                type={type}
                name={name}
                value={value}
                placeholder={placeholder}
                disabled={disabled}
                autoFocus={autoFocus}
                autoComplete={autoComplete}
                min={min}
                max={max}
                step={step}
                aria-invalid={invalid || undefined}
                aria-describedby={describedBy}
                onChange={(event) => onChange(event.target.value)}
                onBlur={onBlur}
                className={`w-full rounded-md border bg-surface px-3.5 py-2.5 text-base text-text outline-none placeholder:text-text-muted/55 disabled:opacity-60 ${
                    invalid ? 'border-error' : 'border-border-strong focus:border-secondary'
                }`}
            />

            {hint ? (
                <span className={`mt-1.5 block text-sm ${invalid ? 'text-error' : 'text-text-muted'}`}>{hint}</span>
            ) : null}
        </label>
    );
}
